export default __webpack_public_path__ + "images/assets/1202a6c17f590456b088b72c77502b03.svg";